import api from "../services/api";

export const fetchReviews = async ({
  rating_type = null,
  driver_id = null,
  target_user_id = null,
  mode = "all",
  page = 1,
  size = 50,
} = {}) => {
  try {
    const params = { mode, page, size };

    if (rating_type) params.rating_type = rating_type;
    if (driver_id) params.driver_id = driver_id;
    if (target_user_id) params.target_user_id = target_user_id;

    const response = await api.get("/review-management/reviews/", { params });

    const payload = response.data?.data;

    const items = Array.isArray(payload?.items) ? payload.items : [];
    const pagination = payload?.pagination || {
      page,
      size,
      total: items.length,
      pages: 1,
    };

    return { items, pagination };
  } catch (error) {
    console.error("Error fetching reviews:", error);
    return {
      items: [],
      pagination: { page: 1, size: 50, total: 0, pages: 1 },
    };
  }
};